<template>
  <a-card size="small" title="筛选条件" :bordered="false">
    <a-form-model class="search-form">
      <a-form-model-item>
        <a-row>
          <span style="margin-right: 8px">时间:</span>
          <a-range-picker v-model="checkedDate" :default-value="checkedDate" :allow-clear="false" />
          <span style="margin-right: 8px; margin-left: 8px">对比时间:</span>
          <a-range-picker v-model="lastCheckedDate" :default-value="lastCheckedDate" :allow-clear="false" />
          <span style="margin-right: 8px; margin-left: 8px">任务类型:</span>
          <span>
            <a-tree-select v-model="objective" show-search tree-default-expand-all multiple :filter-tree-node="filterModule" :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }" style="width: 15%" :tree-data="objectiveData" />
          </span>
        </a-row>
      </a-form-model-item>
      <a-form-model-item>
        <span style="margin-right: 8px">团队:</span>
        <a-checkable-tag :checked="selectedTeams.length === 0" @change="selectedTeams = []">全部</a-checkable-tag>
        <a-checkable-tag v-for="team in teams" :key="team.id" :checked="selectedTeams.indexOf(team.id) > -1" @change="checked => handleChange(team.id, checked)">
          {{ team.name }}
        </a-checkable-tag>
      </a-form-model-item>
    </a-form-model>
  </a-card>
</template>

<script>
import moment from 'moment';
import { diagramList } from '@/api/system/team';
import { tagList } from '@/api/system/tag';

export default {
  name: 'DataFilter',
  data() {
    return {
      checkedDate: [moment().subtract(1, 'month').add(1, 'day'), moment()],
      objective: [],
      objectiveData: [
        { key: 1, value: 1, disabled: true, title: '编码任务', children: [] },
        { key: 2, disabled: true, value: 2, title: '非编码任务', children: [] }
      ],
      lastCheckedDate: [moment().subtract(1, 'month').add(1, 'day'), moment()],
      labelCol: { span: 1 },
      wrapperCol: {},
      checkAll: true,
      indeterminate: false,
      plainOptions: [],
      teams: [],
      selectedTeams: []
    };
  },

  computed: {
    filter() {
      const { checkedDate, selectedTeams, lastCheckedDate, objective } = this;
      return {
        checkedDate,
        selectedTeams,
        lastCheckedDate,
        objective
      };
    }
  },

  watch: {
    filter() {
      this.$emit('change', this.checkedDate, this.selectedTeams, this.lastCheckedDate, this.objective);
    }
  },
  created() {
    this.getTeamList();
    this.getObjectiveList();
    this.$emit('change', this.checkedDate, this.selectedTeams, this.lastCheckedDate, this.objective);
  },

  methods: {
    filterModule(searchValue, treeNode) {
      return treeNode.data.props.title.includes(searchValue);
    },
    handleChange(team_id, checked) {
      const { selectedTeams } = this;
      const nextSelectedTeams = checked ? [...selectedTeams, team_id] : selectedTeams.filter(t => t !== team_id);
      this.selectedTeams = nextSelectedTeams;
    },
    getObjectiveList() {
      tagList({ group_code: 'coding_task' }).then(res => {
        const children = res.data.items.map(item => ({
          key: item.id,
          value: item.id,
          title: item.name
        }));
        this.objectiveData[0].children = children;
      });
      tagList({ group_code: 'un_coding_task' }).then(res => {
        const children = res.data.items.map(item => ({
          key: item.id,
          value: item.id,
          title: item.name
        }));
        this.objectiveData[1].children = children;
      });
    },

    // 获取团队列表
    getTeamList() {
      diagramList({ category: 1 }).then(res => {
        this.teams = res.data.items;
      });
    }
  }
};
</script>

<style lang="less" scoped>
.ant-form-item {
  margin-bottom: 0px;
  border-bottom: silver 1px dashed;
}
</style>
